import React, { useState } from 'react';
import { Menu, X, ChevronDown, Globe } from 'lucide-react';
import translations, { languageNames } from '@/i18n/translations';

export const Navbar = ({ t, language, changeLanguage, scrollToSection }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [languageMenuOpen, setLanguageMenuOpen] = useState(false);

  const handleLanguageChange = (lang) => {
    changeLanguage(lang);
    setLanguageMenuOpen(false);
  };

  const handleNav = (id) => {
    scrollToSection(id);
    setMobileMenuOpen(false);
  };

  return (
    <nav className="fixed w-full bg-white/95 backdrop-blur-sm shadow-md z-50" data-testid="main-navigation">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center" data-testid="company-logo">
            <img
              src="https://customer-assets.emergentagent.com/job_file-based-website-1/artifacts/8c8z99e7_Jurgen%20Anlumax.PNG"
              alt="AnluMAX Logo"
              className="h-12 md:h-14"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => handleNav('home')} className="text-gray-700 hover:text-blue-600 transition-colors" data-testid="nav-home">{t.nav.home}</button>
            <button onClick={() => handleNav('about')} className="text-gray-700 hover:text-blue-600 transition-colors" data-testid="nav-about">{t.nav.about}</button>
            <button onClick={() => handleNav('industries')} className="text-gray-700 hover:text-blue-600 transition-colors" data-testid="nav-industries">{t.nav.industries}</button>
            <button onClick={() => handleNav('standards')} className="text-gray-700 hover:text-blue-600 transition-colors" data-testid="nav-standards">{t.nav.standards}</button>
            <button onClick={() => handleNav('safety')} className="text-gray-700 hover:text-blue-600 transition-colors" data-testid="nav-safety">{t.nav.safety}</button>

            <div className="relative">
              <button
                onClick={() => setLanguageMenuOpen(!languageMenuOpen)}
                className="flex items-center space-x-2 text-gray-700 hover:text-blue-600 transition-colors"
                data-testid="language-selector"
              >
                <Globe size={20} />
                <span>{languageNames[language]}</span>
                <ChevronDown size={16} />
              </button>

              {languageMenuOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50" data-testid="language-menu">
                  {Object.keys(translations).map((lang) => (
                    <button
                      key={lang}
                      onClick={() => handleLanguageChange(lang)}
                      className={`block w-full text-left px-4 py-2 hover:bg-blue-50 transition-colors ${
                        language === lang ? 'text-blue-600 font-semibold' : 'text-gray-700'
                      }`}
                      data-testid={`language-option-${lang}`}
                    >
                      {languageNames[lang]}
                    </button>
                  ))}
                </div>
              )}
            </div>

            <button onClick={() => handleNav('contact')} className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors" data-testid="nav-contact">{t.nav.contact}</button>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-gray-700"
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden py-4" data-testid="mobile-menu">
            <button onClick={() => handleNav('home')} className="block w-full text-left py-2 text-gray-700 hover:text-blue-600">{t.nav.home}</button>
            <button onClick={() => handleNav('about')} className="block w-full text-left py-2 text-gray-700 hover:text-blue-600">{t.nav.about}</button>
            <button onClick={() => handleNav('industries')} className="block w-full text-left py-2 text-gray-700 hover:text-blue-600">{t.nav.industries}</button>
            <button onClick={() => handleNav('standards')} className="block w-full text-left py-2 text-gray-700 hover:text-blue-600">{t.nav.standards}</button>
            <button onClick={() => handleNav('safety')} className="block w-full text-left py-2 text-gray-700 hover:text-blue-600">{t.nav.safety}</button>

            <div className="py-2 border-t border-gray-200 mt-2">
              <div className="text-gray-500 text-sm px-2 mb-2">Language</div>
              {Object.keys(translations).map((lang) => (
                <button
                  key={lang}
                  onClick={() => handleLanguageChange(lang)}
                  className={`block w-full text-left py-2 px-4 ${
                    language === lang ? 'text-blue-600 font-semibold' : 'text-gray-700'
                  }`}
                  data-testid={`mobile-language-option-${lang}`}
                >
                  {languageNames[lang]}
                </button>
              ))}
            </div>

            <button onClick={() => handleNav('contact')} className="block w-full text-left py-2 text-gray-700 hover:text-blue-600">{t.nav.contact}</button>
          </div>
        )}
      </div>
    </nav>
  );
};
